export const AG_GRID_LICENSE = import.meta.env.VITE_AG_GRID_LICENSE ?? '';

const truthyStringRecord: Record<TruthyString, true> = {
  true: true,
  '1': true,
  on: true,
  yes: true,
  enabled: true
};

// global
export const IN_TEST = import.meta.env.NODE_ENV === 'test';
export const IN_PRODUCTION = import.meta.env.VITE_APP_ENV === 'prod';
export const ENV = IN_PRODUCTION ? 'production' : IN_TEST ? 'test' : 'development';

// amplitude
export const AMPLITUDE_API_TOKEN = import.meta.env.VITE_AMPLITUDE_API_TOKEN ?? '';
export const AMPLITUDE_API_ENDPOINT = import.meta.env.VITE_AMPLITUDE_API_ENDPOINT ?? '';
export const AMPLITUDE_CDN_URL = import.meta.env.VITE_AMPLITUDE_CDN_URL ?? '';
export const AMPLITUDE_ENABLED = !!(!IN_TEST && AMPLITUDE_API_TOKEN);
export const AMPLITUDE_ENGAGEMENT_SERVER_URL = import.meta.env.VITE_AMPLITUDE_ENGAGEMENT_SERVER_URL ?? '';
export const AMPLITUDE_SESSION_REPLAY_CONFIG_URL = import.meta.env.VITE_AMPLITUDE_SESSION_REPLAY_CONFIG_URL ?? '';
export const AMPLITUDE_SESSION_REPLAY_TRACK_URL = import.meta.env.VITE_AMPLITUDE_SESSION_REPLAY_TRACK_URL ?? '';
export const AMPLITUDE_WELCOME_TOUR_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_WELCOME_TOUR_GUIDE_KEY ?? '';
export const AMPLITUDE_FIELD_SCHEDULES_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_FIELD_SCHEDULES_GUIDE_KEY ?? '';
export const AMPLITUDE_GETTING_STARTED_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_GETTING_STARTED_GUIDE_KEY ?? '';
export const AMPLITUDE_ORGANIZATION_DASHBOARDS_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_ORGANIZATION_DASHBOARDS_GUIDE_KEY ?? '';
export const AMPLITUDE_PHASE_PLANNING_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_PHASE_PLANNING_GUIDE_KEY ?? '';
export const AMPLITUDE_PROJECT_DASHBOARDS_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_PROJECT_DASHBOARDS_GUIDE_KEY ?? '';
export const AMPLITUDE_RESOURCE_LOADING_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_RESOURCE_LOADING_GUIDE_KEY ?? '';
export const AMPLITUDE_RISK_SIMULATION_GUIDE_KEY = import.meta.env.VITE_AMPLITUDE_RISK_SIMULATION_GUIDE_KEY ?? '';

// datadog
export const DATADOG_APPLICATION_ID: string = import.meta.env.VITE_DATADOG_APPLICATION_ID ?? '';
export const DATADOG_CLIENT_TOKEN: string = import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? '';
export const DATADOG_ENABLED: boolean = Object.hasOwn(truthyStringRecord, (import.meta.env.VITE_DATADOG_ENABLED ?? '').toLowerCase());
export const DATADOG_ENVIRONMENT = import.meta.env.VITE_DATADOG_ENVIRONMENT ?? '';
export const DATADOG_SERVICE: string = import.meta.env.VITE_DATADOG_SERVICE ?? '';
export const DATADOG_TRACING_URL = import.meta.env.VITE_REMOTE_BASE_URL ?? '';
export const DATADOG_VERSION = import.meta.env.VITE_DATADOG_VERSION ?? '';
export const VERCEL_DEPLOYMENT_ID = import.meta.env.VITE_VERCEL_DEPLOYMENT_ID ?? '';

// api gateway (kong)
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '';
export const BASE_URL_KEY = 'base_url';
export const LOCALHOST_BASE_URL = 'http://localhost:9000';
export const REMOTE_BASE_URL = import.meta.env.VITE_REMOTE_BASE_URL || 'https://kong.dev.planera.io';
export const REMOTE_CHAT_SERVER_URL = import.meta.env.VITE_CHAT_SERVER_URL || REMOTE_BASE_URL;
export const LOCALHOST_CHAT_SERVER_URL = 'http://localhost:5016';
export const LIVEBLOCKS_URL = 'wss://api.liveblocks.io/v6';
export const STREAM_API_KEY = import.meta.env.VITE_STREAM_API_KEY ?? 'az5x9ctfdd47';
export const STREAM_APP_ID = import.meta.env.VITE_STREAM_APP_ID ?? '1211641';
export const LOCAL_STREAM_API_KEY = import.meta.env.VITE_LOCAL_STREAM_API_KEY ?? '7df2mmgmys3x';
export const LOCAL_STREAM_APP_ID = import.meta.env.VITE_LOCAL_STREAM_APP_ID ?? '1211750';
